var deserialize_err_msg = "BUG: Attempting to deserialize to uninhabited type Void.t.";
export { deserialize_err_msg };
/* No side effect */